module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title-banner":"Sonotron behind<br /> the scenes","subtitle-banner":"A place to look, <br />listen & learn","card-btn":"Check it","all":"All"},"fr":{"title-banner":"Les coulisses du&nbsp;Sonotron","subtitle-banner":"Un endroit pour voir, écouter et apprendre","card-btn":"Voir","all":"Tout"}}')
  delete Component.options._Ctor
}
